$('.custom-responsive-slider').slick({
  dots: false,
  arrows:true,
  infinite: true,
  autoplay:true,
  speed: 200,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});



// related products

 function initializeSlickSlider() {
  const $slider = $('.custom-related-products-slider');
  if (window.matchMedia('(max-width: 989px)').matches) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });

   
      $slider.on('setPosition', () => {
        $slider.find('.slick-list').css({ paddingRight: '40px', paddingLeft: 0 });
      });
    }
  } else if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
}
setTimeout(initializeSlickSlider, 3000);
$(window).on('resize', initializeSlickSlider);




// recently viewed products
